import { z } from 'zod';

/* Contratos de license-ops do backoffice (Epic 28 / ADR-0350). "License" = entitlement
   de pack (não há tabela `licenses` — são JWTs KMS). O admin orquestra o licensing via
   HMAC. `reason` mais estrito em ops que afetam device (cooldown) ou são super_admin
   (issue-manual). A justificativa fica na trilha de auditoria (28-03), não no entitlement. */

/* revoke: packId vem do path; body só carrega o motivo. */
export const revokeLicenseBody = z.object({ reason: z.string().min(10).max(500) });
export type RevokeLicenseBody = z.infer<typeof revokeLicenseBody>;

/* transfer: move o entitlement de `packId` do user do path → `toUserId` (mesma org). */
export const transferLicenseBody = z.object({
  toUserId: z.string().min(1),
  packId: z.string().min(1),
  reason: z.string().min(10).max(500),
});
export type TransferLicenseBody = z.infer<typeof transferLicenseBody>;

/* issue-manual (super_admin): concede um pack fora de Stripe. `justificationKind`
   categoriza (comp/beta/internal) p/ reporting; `reason` ≥20 = justificativa detalhada. */
export const issueManualLicenseBody = z.object({
  packId: z.string().min(1),
  version: z.string().min(1).default('*'),
  justificationKind: z.enum(['comp', 'beta', 'internal']),
  reason: z.string().min(20).max(500),
  expiresAt: z.string().datetime().optional(),
});
export type IssueManualLicenseBody = z.infer<typeof issueManualLicenseBody>;

/* cooldown: soft-block temporário de device (deviceId no path). max 720h (30d);
   reason ≥20 (afeta o device, não só uma license individual). */
export const cooldownDeviceBody = z.object({
  durationHours: z.number().int().min(1).max(720),
  reason: z.string().min(20).max(500),
});
export type CooldownDeviceBody = z.infer<typeof cooldownDeviceBody>;
